import React, {useContext} from 'react';
import {Icon} from '@bonprix/design-system';
import {HeaderContext} from '@header/scripts/components/context/HeaderContext.jsx';

export default function HeaderIconWithBadge({iconName, count, checked = false}) {
    const {headerLightMode} = useContext(HeaderContext);
    const content = checked ? '\u2713' : count;

    const badgeColorClasses = headerLightMode
        ? 'text-clr-primary bg-clr-on-primary-high'
        : 'text-clr-on-primary-high bg-clr-primary';

    return (
        <div className="header__icon-with-badge">
            <Icon variant={iconName} className={`${headerLightMode ? 'fill-clr-on-primary-high' : ''}`} />
            {(count || checked) && <span className={`header-icon__badge ${badgeColorClasses}`}>{content}</span>}
        </div>
    );
}
